import React, { useCallback } from 'react';
import { formatNumberToLocaleString } from '@utils/math';
import { transformToTitleCase } from '@utils/string';
import { STATISTIC_HEADERS } from '@constants/details-header';
import { IPipelineStatistics } from '@redux/types/types';
import ListCarousel from '@components/common/ListCarousel/ListCarousel';
import styles from './pipelineStatistics.module.scss';

interface IPipelineStatisticsComponent {
  pipelineStatistics: IPipelineStatistics;
  setActiveTabPipelineDetailsPage?: (tab: string) => void;
}

const PipelineStatistics = (props: IPipelineStatisticsComponent) => {
  const { pipelineStatistics } = props;

  const getStatisticsOptions = useCallback(() => {
    return Object.keys(pipelineStatistics).map((statistic) => {
      const option = {
        key: statistic,
        label:
          STATISTIC_HEADERS[statistic as keyof typeof STATISTIC_HEADERS] ||
          transformToTitleCase(statistic),
        value: formatNumberToLocaleString(
          pipelineStatistics[statistic as keyof IPipelineStatistics],
          true,
        ),
      };
      return option;
    });
  }, [pipelineStatistics]);

  return (
    <section className={styles.section}>
      <ListCarousel options={getStatisticsOptions()} />
    </section>
  );
};

export default PipelineStatistics;
